module.exports = __webpack_public_path__ + "static/thing-40698d09392f458ce90428e5b24f7921.png";